import * as React from 'react';
import autobind from 'autobind-decorator';

//Components
import { Form, Row, Col, Button } from 'react-bootstrap';
// NewmdTextarea 
// LoadingBar


interface IProps {
    cancelCallback: any;
    saveCallback: any;
    type: string;
}

interface IState {
    is_quiz_video: boolean;
    loading: boolean;
}

export default class AddElementForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            is_quiz_video: false,
            loading: false
        }

    }


    @autobind
    public onSave(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const formData = new FormData();
        console.log(form);
        Array.from(form.elements).forEach((e, i) => {
            if (e['type'] === 'file') {
                if (!e['files'][0]) formData.append(e['id'], new File([""], ""));
                else formData.append(e['id'], e['files'][0])
            }
            else if (e['type'] !== "submit") {
                if (this.props.type === "video" && e['id'] === "description") formData.append('content', e['value'])
                else formData.append(e['id'], e['value'])
            }
        })
        formData.append('is_quiz_video', String(this.state.is_quiz_video));
        this.props.saveCallback(this.props.type, formData)
    }

    public render() {
        let form = null;
        if (this.props.type === 'video') {
            form = [['Video File', 'video_file'], ['Camtasia Config File', 'video_config_file'], ['Slides etc.', 'other_file']].map((e) => {
                return (

                    <Form.Group key={e[1]} as={Row} controlId={e[1]}>
                        <Form.Label column sm={2}>
                            {e[0]}
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control type="file" />
                        </Col>
                    </Form.Group>
                )
            })
        } else if (this.props.type === 'document') {
            form = (
                <Form.Group as={Row} controlId="document_file">
                    <Form.Label column sm={2}>
                        Document
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Control type="file" />
                    </Col>
                </Form.Group>

            );
        }
        else {
            form = <div>Render quiz here </div>
        }
        if (this.state.loading) {
            return (
                <p>Loading...</p>
            );
        }

        return (
            <React.Fragment>

                <Form onSubmit={this.onSave}>
                    <Form.Group as={Row} controlId="title">
                        <Form.Label column sm={2}>
                            Title
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control required type="text" placeholder="Title..." />
                        </Col>
                    </Form.Group>
                    {form}
                    <Form.Group as={Row} controlId="description">
                        <Form.Label column sm={2}>
                            Description
                        </Form.Label>
                        <Col sm={10}>
                            <Form.Control as="textarea" rows={4} placeholder="Description..." />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                        <Col sm={{ span: 4, offset: 4 }}>
                            <Button type="submit">Save</Button>
                        </Col>
                    </Form.Group>
                </Form>
            </React.Fragment>

        );
    }
}


